/* Progressive enhancement only. No opacity staging; native forms work without JS. */
(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const running = new Set();
  const restore = () => {
    running.forEach(({node, animation}) => {
      try { animation.stop(); } catch (_) { /* Keep content natural. */ }
      node.style.removeProperty('transform');
      node.style.removeProperty('opacity');
    });
    running.clear();
  };
  function enhance(scope = document) {
    if (reduced.matches || document.visibilityState !== 'visible') return;
    const motion = window.Motion;
    if (!motion || typeof motion.animate !== 'function') return;
    scope.querySelectorAll('[data-pw-enhance]:not([data-pw-ready])').forEach(node => {
      node.dataset.pwReady = 'true';
      const rect = node.getBoundingClientRect();
      if (rect.top > window.innerHeight || rect.bottom < 0) return;
      try {
        const animation = motion.animate(node, { y: [8, 0] }, { duration: 0.5, ease: [0.22, 1, 0.36, 1] });
        const record = { node, animation };
        running.add(record);
        Promise.resolve(animation).then(() => {
          node.style.removeProperty('transform');
          running.delete(record);
        }, restore);
      } catch (_) {
        node.style.removeProperty('transform');
      }
    });
  }
  const closeMenus = () => document.querySelectorAll('.pw-nav-group[open]').forEach(node => { node.open = false; });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const opened = document.querySelector('.pw-nav-group[open], .pw-mobile-nav[open]');
    if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.pw-menu-list')) closeMenus();
  });
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('visibilitychange', restore);
  window.addEventListener('focus', restore);
  window.addEventListener('resize', restore, { passive: true });
  reduced.addEventListener('change', restore);
  window.setTimeout(restore, 1600);
  window.setTimeout(restore, 3500);
  enhance();
})();

/* Live-QA hotfix: keyboard access for compare triggers. */
document.querySelectorAll('.js-btn-compare').forEach(function(el){if(!el.hasAttribute('tabindex')){el.setAttribute('role','button');el.setAttribute('tabindex','0');el.addEventListener('keydown',function(ev){if(ev.key==='Enter'||ev.key===' '){ev.preventDefault();el.click();}});}});

/* Live-QA hotfix: strip MYR code suffix from rendered prices (shop money format is read-only). */
(function(){
  var re=/[ \u00a0\u202f]MYR\b/g;
  function cleanText(root){
    if(!root||!root.querySelectorAll)return;
    var nodes=root.querySelectorAll('.money');
    if(root.matches&&root.matches('.money'))nodes=[root].concat([].slice.call(nodes));
    nodes.forEach(function(el){
      var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null),n,dirty=false;
      while((n=w.nextNode())){if(n.nodeValue&&re.test(n.nodeValue)){n.nodeValue=n.nodeValue.replace(re,'');dirty=true;}}
      if(dirty&&el.classList.contains('pw-price')===false){/* keep containers intact */}
    });
  }
  function start(){
    cleanText(document.body);
    var mo=new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var m=muts[i];
        if(m.type==='characterData'&&m.target.parentElement)cleanText(m.target.parentElement);
        else if(m.type==='childList')for(var j=0;j<m.addedNodes.length;j++){var a=m.addedNodes[j];if(a.nodeType===1)cleanText(a);else if(a.nodeType===3&&a.parentElement)cleanText(a.parentElement);}
      }
    });
    mo.observe(document.body,{subtree:true,childList:true,characterData:true});
  }
  if(document.readyState!=='loading')start();else document.addEventListener('DOMContentLoaded',start);
})();
